export default "<div class=\"chart-container\">\n    <canvas width=\"100\" height=\"50\" id=\"bar\" #canvas>{{chart}}</canvas>\n</div>\n"